export const onDeleteProject = id => ({
  widget: 'projects',
  type: 'onDeleteProject',
  payload: { id },
})



// WEBPACK FOOTER //
// ./src/projects/actions/onDeleteProject.js